<template>
    <div class="form-content-wrapper">
        <h6 class="form-title">DATA STNK</h6>
        <div class="submit-btn-wrapper mb-2">
            <b-button name="copyIdentitasBtn" variant="pgiBtn" @click="copy">SALIN DATA IDENTITAS KE DATA STNK</b-button>
        </div>
        <b-row>
            <b-col lg="4" md="6">
                <b-form-group label="STNK Atas Nama">
                    <b-form-input v-model="dataStnk.namaStnk" name="gadaiNamaStnk" required></b-form-input>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Kota STNK">
                    <multiselect
                        name="kota"
                        v-model="dataStnk.kotaStnk"
                        :options="kota" 
                        :internal-search="false"
                        :loading="isLoadingKota"
                        @search-change="searchTempat"
                        :allow-empty="false"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="name"
                        placeholder="*Ketik min. 4 huruf untuk mencari..."
                    />
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Kecamatan STNK">
                    <b-input-group>
                        <b-form-select v-if="kecLoading == true" v-model="data" name="dataAnggotaKecamatan" disabled>
                            <template v-slot:first>
                                <b-form-select-option value="null" disabled>Mengambil data ...</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select v-else v-model="dataStnk.kecamatanStnk" name="dataAnggotaKecamatan" :options="listKecamatan" value-field="id" text-field="name" required>
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Kelurahan STNK">
                    <b-input-group>
                        <b-form-select v-if="kelLoading == true" v-model="data" name="dataAnggotaKelurahan" disabled>
                            <template v-slot:first>
                                <b-form-select-option value="null" disabled>Mengambil data ...</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select v-else v-model="dataStnk.kelurahanDesaStnk" name="dataAnggotaKelurahan" :options="listKelurahan" value-field="id" text-field="name" required>
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="RT">
                    <b-form-input v-model="dataStnk.rtStnk" name="stnkNort" maxlength="3" title="Gunakan format 3 angka (contoh: 001)" required></b-form-input>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="RW">
                    <b-form-input v-model="dataStnk.rwStnk" name="stnkNorw" maxlength="3" title="Gunakan format 3 angka (contoh: 001)" required></b-form-input>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Alamat STNK">
                    <b-form-textarea v-model="dataStnk.alamatStnk" name="gadaiAlamatStnk" required></b-form-textarea>
                </b-form-group>
            </b-col>
            <b-col lg="4" md="6">
                <b-form-group label="Masa berlaku pajak STNK" :disabled="jenisKendaraan.id == null || kondisi == null ?true :false">
                    <b-form-input  v-model="dataStnk.masaBerlakuStnk" name="gadaiMasaBerlakuStnk" type="date" required @blur="onBlurTanggalPajak"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        
        <ModalConfirm id="modal-confirm-copy-identitas" title="Confirm Copy Data Identitas ke Anggota" desc="Apakah anda yakin untuk mengisi bagian Anggota dengan data dari Identitas?" @submit="onCopyDataIdentitas" />
    </div>
</template>

<script>
export default {
    name: 'data-stnk',
    props: {
        dataStnk: { type: Object, required: true },
        copyStnk: { type: Object, required: true },
        anggota: { type: Object, required: true },
        jenisKendaraan : {type : Object},
        kondisi : {type : Object},
    },
    data(){
        return{
            isLoadingKota: false,
            activeSearchKota: null,
            data: null,
            kota: [],
            kecLoading: false,
            kelLoading: false,
            listKecamatan: [],
            listKelurahan: []
        }
    },
    watch: {
        "jenisKendaraan": function() {
            this.dataStnk.masaBerlakuStnk = ''
        },
        "dataStnk.rtStnk": function(newValue) {
            const result = newValue.replace(/[^\d]/g,'');
            this.$nextTick(() => this.dataStnk.rtStnk = result);
        },
        "dataStnk.rwStnk": function(newValue) {
            const result = newValue.replace(/[^\d]/g,'');
            this.$nextTick(() => this.dataStnk.rwStnk = result);
        },
        //----------------- Pantau Data Identitas -----------------

        'dataStnk.kotaStnk': function(x){
            if (x.id != undefined){
                this.kecLoading = true

                if(this.dataStnk.copy == false){
                    this.dataStnk.kecamatanStnk = null
                    this.dataStnk.kelurahanDesaStnk = null
                }

                if(x.id != this.copyStnk.kota.id){
                    this.dataStnk.kecamatanStnk = null
                    this.dataStnk.kelurahanDesaStnk = null
                }
           
                this.listKecamatan = []
                this.listKelurahan = []
                this.$axios.get(`area/kecamatan/${x.id}`).then(response => {
                    this.listKecamatan = response.data
                    this.kecLoading = false
                })
                .catch(error => {
                    console.log(error)
                    this.kecLoading = false
                    this.$helper.parseError(this, error)
                })
            }
        },

        'dataStnk.kecamatanStnk': function(id){
            if (id != null){
                this.kelLoading = true
                this.listKelurahan = []
                if(id != this.copyStnk.kecamatan){
                    this.dataStnk.kelurahanDesaStnk = null
                }
                this.$axios.get(`area/kelurahan/${id}`).then(response => {
                    this.listKelurahan = response.data
                    this.kelLoading = false
                })
                .catch(error => {
                    this.kelLoading = false
                    this.$helper.parseError(this, error)
                })
            }
        },
    },
    methods: {
        searchTempat(searchQuery) {
            if (searchQuery.length >= 4){
                this.isLoadingKota = true

                if (this.activeSearchKota == null) this.activeSearchKota = setTimeout(() => { this.searchKota(searchQuery) }, 1000)
                else {
                    clearTimeout(this.activeSearchKota)
                    this.activeSearchKota = setTimeout(() => { this.searchKota(searchQuery) }, 1000)
                }
            } 
            else {
                clearTimeout(this.activeSearchKota)
                this.activeSearchKota = null
                this.isLoadingKota = false
            }
        },
        searchKota(searchQuery) { 
            this.$axios.get('area/search/kota/?name='+searchQuery).then(response => {
                this.kota = response.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isLoadingKota = false
                this.activeSearchKota = null
            })
        },
        loadKecamatan(){
            this.kecLoading = true
            this.loadKecFail = false
            this.$axios.get(`area/kecamatan/${this.kota.id}`).then(response => {
                this.listKecamatan = response.data
                this.kecLoading = false
            })
            .catch(error => {
                this.input.dataAnggota.loadKecFail = true
                this.$helper.parseError(this, error)
            })
        },
        loadKelurahan(){
            this.kelLoading = true
            this.$axios.get(`area/kelurahan/${this.dataStnk.kecamatanStnk}`).then(response => {
                this.listKelurahan = response.data
                this.kelLoading = false
            })
            .catch(error => {
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },
        copy(){
            this.$bvModal.show("modal-confirm-copy-identitas")
        },
        onCopyDataIdentitas(){
            if(this.anggota.id == null) {
                this.$bvModal.hide("modal-confirm-copy-identitas")
                this.$helper.toastErr(this, "Mohon memilih anggota terlebih dahulu!")
                return
            }
            this.dataStnk.copy = true;
            
            this.dataStnk.alamatStnk = this.copyStnk.alamat
            this.dataStnk.kotaStnkId = this.copyStnk.kota.id
            this.dataStnk.kotaStnk = this.copyStnk.kota
            this.dataStnk.rtStnk = this.copyStnk.rt
            this.dataStnk.rwStnk = this.copyStnk.rw

            this.dataStnk.kecamatanStnk = this.copyStnk.kecamatan
            this.dataStnk.kelurahanDesaStnk = this.copyStnk.kelurahan

            this.dataStnk.copy = true;
            
            this.$bvModal.hide("modal-confirm-copy-identitas")
        },
         onBlurTanggalPajak() {
            const result = this.$helper.validateBatasMasaPajak(this.dataStnk.masaBerlakuStnk);

            if (!result.valid) {
                this.$helper.toastErr(this, result.message);
                return;
            }
        }
    },
}
</script>